export default "__VITE_ASSET__CJ$pHmK3__"